import {
  Card,
  Typography,
  Box,
  Breadcrumbs,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const ItemDetail = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const handlePrevScreen = () => {
    navigate("/firehouse/items");
  };
  return (
    <>
      <Card
        className="shadow py-5 px-4 "
        style={{
          margin: isMobile ? "20px" : "24px 60px 14px 30px",
          position: "relative",
        }}
      >
        <img
          src="/images/arrow-icon.svg"
          onClick={handlePrevScreen}
          style={{
            cursor: "pointer",
            position: "absolute",
            top: "18px",
            right: "26px",
          }}
          alt="close"
        />
        <Box className="d-flex align-items-center gap-2 mb-2">
          Location :{" "}
          <Typography variant="h6" fontWeight={700}>
            Wire 3
          </Typography>
        </Box>
        <Box>
          <Breadcrumbs
            separator=">>"
            aria-label="breadcrumb"
            //   sx={{
            //     display: "flex",
            //     alignItems: "center",
            //   }}
          >
            <img src="/images/Home.svg" />
            <span>Station 1 </span>
            <span>Engine Bay 1 </span>
            <span>Vehicle 1 </span>
          </Breadcrumbs>
        </Box>
        <Card
          style={{
            border: "1px solid #CCCCCC",
            marginTop: isMobile ? "56px" : "24px",
          }}
        >
          <Grid
            container
            spacing={3}
            style={{
              position: "relative",
              padding: isMobile ? "16px" : "48px",
            }}
          >
            <Grid
              item
              xs={12}
              lg={7}
              style={{ padding: isMobile ? "24px" : "48px" }}
            >
              <img
                src="/images/wheel.png"
                width={200}
                height={200}
                style={{ display: "flex", margin: isMobile ? "auto" : "0" }}
              />
              <Typography
                variant="h6"
                fontWeight={700}
                component="h3"
                className="mt-3"
                style={{ textAlign: isMobile ? "center" : "left" }}
              >
                Wheel Chocks
              </Typography>
              <Typography style={{ textAlign: isMobile ? "center" : "left" }}>
                <div className="mt-1">
                  Quantity : <span style={{ fontWeight: "600" }}>30</span>
                </div>
              </Typography>
              <Typography
                className="my-3"
                style={{ textAlign: isMobile ? "center" : "left" }}
              >
                In publishing and graphic design, Lorem ipsum is a placeholder
                text commonly used In publishing and graphic design, Lorem ipsum
                is a placeholder text commonly used 
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  marginTop: 4,
                  justifyContent: isMobile ? "center" : "left",
                }}
              >
                <img src="/images/edit.svg" style={{ cursor: "pointer" }}></img>
                <img src="/images/eye.svg" style={{ cursor: "pointer" }}></img>
                <img
                  src="/images/info-icon.svg"
                  style={{ cursor: "pointer" }}
                ></img>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              lg={5}
              style={{
                padding: isMobile ? "22px 40px 0" : "24px 0 0 24px",
              }}
            >
              <Typography variant="h6" fontWeight={700} component="h3">
                Past reported issues
              </Typography>
              <Box
                style={{
                  border: "1px solid #CCCCCC",
                  backgroundColor: "#F5F5F5",
                  borderRadius: "20px",
                  padding: "20px 28px",
                  marginTop: "24px",
                }}
              >
                <Typography>
                  <div className="mt-1">
                    Date : <span style={{ fontWeight: "600" }}>XX/XX/XXXX</span>
                  </div>
                </Typography>
                <Typography>
                  <div className="mt-1">
                    Quantity : <span style={{ fontWeight: "600" }}>10</span>
                  </div>
                </Typography>
              </Box>
            </Grid>
            <div
              style={{
                position: "absolute",
                top: isMobile ? "" : 0,
                bottom: isMobile ? "26%" : 0,
                left: isMobile ? 0 : "56%",
                width: isMobile ? "100%" : "1px",
                backgroundColor: "#CCCCCC",
                height: isMobile ? "2px" : "100%",
              }}
            ></div>
          </Grid>
        </Card>
      </Card>
    </>
  );
};

export default ItemDetail;
